var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.448,
    height: 20.819,
    viewBox: "0 0 26.448 20.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.448,
    height: 20.819,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23.242,
    transform: "translate(0 10.41)",
    fill: "none",
    stroke: "#f8f3ff",
    strokeLinejoin: "bevel",
    strokeWidth: 2.919
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.608,0c0,6.277,7.272,10.41,10.839,10.41",
    fill: "none",
    stroke: "#f8f3ff",
    strokeLinejoin: "bevel",
    strokeWidth: 2.919
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.608,20.819c0-6.277,7.272-10.409,10.839-10.409",
    fill: "none",
    stroke: "#f8f3ff",
    strokeLinejoin: "bevel",
    strokeWidth: 2.919
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.848112bf0ccbc70bb8079983b50f4b40.svg";
export { ForwardRef as ReactComponent };